<template>
  <div class="main-wrap" :class="{'main-wrap-full':!$parent.isCollapse }">
   <div class="main-top-button">
      <div class="con">
        <div class="icon-side-collapse" @click="showCollapse" ></div>
        <!-- <el-button @click="onImport" size="mini" class="btn-import">导入</el-button> -->
        <el-dropdown @command="commandExport">
          <el-button  :loading="btnExportLoading" size="mini" class="btn-review" type="primary" plain>导出<i class="el-icon-arrow-down"></i></el-button>
          <el-dropdown-menu slot="dropdown" class="mini-select">
            <el-dropdown-item command="ExportPart" :disabled="!hasSelect">导出本页勾选项</el-dropdown-item>
            <el-dropdown-item command="ExportAll" v-if="parArray.includes('oms_orderItem_export')">导出全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button @click="onExport" :loading="btnExportLoading" size="mini" class="btn-export" :disabled="!hasSelect">导出</el-button> -->
        <el-dropdown @command="commandAudit">
          <el-button size="mini" class="btn-review" type="primary" plain>审核<i class="el-icon-arrow-down"></i></el-button>
          <el-dropdown-menu slot="dropdown" class="mini-select">
            <el-dropdown-item command="privateAudit" :disabled="!hasSelect">私域订单审核</el-dropdown-item>
            <el-dropdown-item command="publicAudit" :disabled="!hasSelect">公域已付款待审核</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button @click="onSetExpress()" size="mini" class="btn-express" :disabled="!hasSelect">指定快递</el-button>
        <el-button @click="onSetTag()" size="mini" class="btn-set-tag" :disabled="!hasSelect">设置标签</el-button>
        <el-button @click="onSetDate()" size="mini" class="btn-set-date" :disabled="!hasSelect">指定发货日期</el-button>
      </div>
      <div @click="onSetTable" class="btn-set-table" ><i class="icon-set-table" />列表控制</div>
   </div>
   <!-- table 数据 -->
    <div v-loading="loading">
        <lb-table v-horizontal-scroll='"always"' border :column="columns" :data="list" :orderStatistics="orderStatistics" pagination
            @row-contextmenu="rightClick" @row-click="rowClick" :row-class-name="tableRowClassName" :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
            @size-change="handleSizeChange" @p-current-change="handleCurrentChange"
            @selection-change="handleSelectionChange" @refresh="fetchData"> 
        </lb-table>
    </div>
    <!-- 弹窗 -->
     <pop-set-table ref="popSetTable" @hasSetTable="hasSetTable" />
     <pop-set-tag ref="popSetTag" @hasSetTag="hasSetTag"/>
     <pop-set-remark ref="popSetRemark" @fetchData="fetchData"/>
     <pop-set-express ref="popSetExpress" @hasSetExpress="hasSetExpress"/>
     <pop-set-date ref="popSetDate" @hasSetDate="hasSetDate"/>
     <pop-order-record ref="popOrderRecord"/>
     <pop-import ref="popImport" @fetchData="fetchData"/>
     <pop-private-audit ref="popPrivateAudit" @fetchData="fetchData"/>
     <pop-public-audit ref="popPublicAudit" @fetchData="fetchData"/>
     <pop-appeal-record ref="popAppealRecord"/>
     <pop-audit-record ref="popAuditRecord"/>
     <pop-result-table ref="popResultTable"/>
     <pop-goods-info ref="popGoodsInfo" @fetchData="fetchData"/>
     <pop-goods-after ref="popGoodsAfter"/>
     <pop-goods-amount ref="popGoodsAmount" @fetchData="fetchData"/>
     <pop-submit-apply ref="popSubmitApply" @fetchData="fetchData"/>
     <pop-check-apply ref="popCheckApply" @fetchData="fetchData"/>
     <pop-logistics ref="popLogistics"/>
     
     <!-- 右键菜单 -->
     <pop-right-click ref="popRightClick" @hasClickMenu="hasClickMenu" /> 
  </div>
</template>
<script>
import LbTable from '@/pages/orderBox/saleOrder/components/lb-table/lb-table'
import popSetTable from '@/pages/orderBox/saleOrder/components/popSetTable/popSetTable'
import popSetTag from '@/pages/orderBox/saleOrder/components/popSetTag/popSetTag'
import popRightClick from '@/pages/orderBox/saleOrder/components/popRightClick/popRightClick'
import popSetRemark from '@/pages/orderBox/saleOrder/components/popSetRemark/popSetRemark'
import popSetExpress from '@/pages/orderBox/saleOrder/components/popSetExpress/popSetExpress'
import popSetDate from '@/pages/orderBox/saleOrder/components/popSetDate/popSetDate'
import popOrderRecord from '@/pages/orderBox/saleOrder/components/popOrderRecord/popOrderRecord'
import popImport from '@/pages/orderBox/saleOrder/components/popImport/popImport'
import popPrivateAudit from '@/pages/orderBox/saleOrder/components/popPrivateAudit/popPrivateAudit'
import popPublicAudit from '@/pages/orderBox/saleOrder/components/popPublicAudit/popPublicAudit'
import popAppealRecord from '@/pages/orderBox/saleOrder/components/popAppealRecord/popAppealRecord'
import popAuditRecord from '@/pages/orderBox/saleOrder/components/popAuditRecord/popAuditRecord'
import popResultTable from '@/pages/orderBox/saleOrder/components/popResultTable/popResultTable'
import popGoodsInfo from '@/pages/orderBox/saleOrder/components/popGoodsInfo/popGoodsInfo'
import popGoodsAfter from '@/pages/orderBox/saleOrder/components/popGoodsAfter/popGoodsAfter'
import popGoodsAmount from '@/pages/orderBox/saleOrder/components/popGoodsAmount/popGoodsAmount'
import popSubmitApply from '@/pages/orderBox/saleOrder/components/popSubmitApply/popSubmitApply'
import popCheckApply from '@/pages/orderBox/saleOrder/components/popCheckApply/popCheckApply'
import popLogistics from '@/pages/orderBox/saleOrder/components/popLogistics/popLogistics'
import tableColumnsMixins from '@/pages/orderBox/saleOrder/mixins/tableColumnsFunction'
import popDialogMixins from '@/pages/orderBox/saleOrder/mixins/popDialogFunction'

import { sessionStorage } from '@/assets/js/storage'
export default {
  name:'saleOrderMain',
  mixins: [tableColumnsMixins,popDialogMixins],
  components: {
    LbTable,popSetTable,popSetTag,popRightClick,popSetRemark,popSetExpress,popSetDate,popOrderRecord,popImport,popPrivateAudit,popAppealRecord,popAuditRecord,popResultTable,popPublicAudit,
    popGoodsInfo,popGoodsAfter,popGoodsAmount,
    popSubmitApply,popCheckApply,popLogistics
  },
  created(){
    sessionStorage.removeItem('saleOrderTable')
    this.getUserTable()
    // 侧边栏功能
    this.$bus.$on('onSelectTag', data=> this.onSetTag(data));
    // 权限设定判断
    let limits = sessionStorage.getItem('limit')
    console.log('limits:',limits)
    const params = limits.buttonTreeDto.filter(
      (item) => item.menuCode === 'saleOrderCode'
    )
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
  },
  activated() {
    this.getCurrentExport()
  },
  beforeDestroy() {
    this.$bus.$off('onSelectTag');
  },
  data () {
    return {
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 },
      columns:[],
      multipleSelection:[],
      visible:true,
      loading:false,
      btnExportLoading:false,
      list:[],
      orderStatistics:{},
      parArray:[],
      // 子组件使用的数据
      flagTags:[],
      textTags:[],
       currentRowId: null,
    }
  },
  computed: {
      hasSelect() {
        return this.multipleSelection.length>0
      },
  },
  methods: {
      showCollapse() {
        this.$parent.isCollapse = true
      },
      handleCurrentChange(currentChange) {
          this.page.pageNo = currentChange
          this.fetchData()
      },
      handleSizeChange(sizeChange) {
          this.page.pageNo = 1
          this.page.currentPage = 1
          this.page.pageSize = sizeChange
          this.fetchData()
      },
        handleSelectionChange(val) {
          this.multipleSelection = val
      },
      // 行被点击
      rowClick(row, column, event){
        this.currentRowId = row.id
        console.log(row, column, event)
      },
      tableRowClassName({row}) {
        return row.id === this.currentRowId ? 'click-row' : '';
      },
      // 右键
      rightClick (row, column, event) {
          // console.log('>>',row.id,row, column, event)
          this.currentRowId = row.id
          let x = event.pageX
          let y = event.pageY
          this.$refs.popRightClick.show(row,x,y)
          event.preventDefault();  // 阻止浏览器默认右键事件
      },
      bodyCloseMenu(e) {
        let self = this
        if (this.$refs.menuRef && !this.$refs.menuRef.contains(e.target)) {
          if (self.menuVisible === true) {
            self.menuVisible = false
          }
        }
      },
      
    // 打开列表控制
    onSetTable(){
      let list = sessionStorage.getItem('saleOrderTable')
      if (!list || (list && list.length===0)) {
        // 弹窗使用默认配置
        this.useDefaultConfig()
      } else {
        this.$refs.popSetTable.show(list)
      }
    },
    // 弹窗使用默认配置
    useDefaultConfig() {
      let newList = []
      this.columns.forEach(e => {
        if (!e.noSet) {
          newList.push(
            {
              id:e.id,
              order:e.id,
              label:e.label,
              align:e.align,
              show:e.show,
              freeze:e.freeze,
              move:0
            }
          )
        }
      })
      this.$refs.popSetTable.show(newList)
    },
    // 使用设置的列表
    setTable(list) {
      const hasSetcolumns = this.orderTableColumns.map(col => {
          const currentItem = list.find(item => item.id === col.id)
          if (currentItem) {
            return {
              ...col,
              align:currentItem.align,
              show:currentItem.show,
              fixed:currentItem.freeze?'left':false,
              order:currentItem.order 
            }
          }return {...col}
        })
      return hasSetcolumns.sort((a, b) => a.order - b.order)
    },
    hasSetTable(list) {
      console.log('>>',list)
      // 修改为通过setter方法赋值
      this.getColumns(list)
    },
    // 设置表单列
     // table列
    getColumns(setList) {
        let list = setList || sessionStorage.getItem('saleOrderTable')
        if (list && list.length > 0) {
          let columns =  this.setTable(list)
          this.columns = columns.filter(item => item.show)
        } else {
          // 使用存储的配置
          this.columns =   this.orderTableColumns
        }
    },
    // 获取个人表单控制列表
    getUserTable(){
      this.$api.omsFormQuery().then(res => {
         let columns = []
        if (res.code == 0 &&  res.data && res.data.jsonPayload) {
          columns = JSON.parse(res.data.jsonPayload)
          console.log('columns:',columns)
          // 新增了49配送方式,防止接口没返回
          const has49 = columns.some(item => item.id == 48)
          if (!has49) {
            columns.push({
              id: 49,
              move: 0,
              show: true,
              align: 'left',
              label: '配送方式',
              order: 49,
              freeze: false
            })
          }
          if (Array.isArray(columns) && columns.length > 0) {
            sessionStorage.setItem('saleOrderTable', columns)
          }
        }
        this.getColumns(columns)
      })
    },
    // 获取是否有导出任务
    getCurrentExport(){
      // this.btnExportLoading = true
      this.$api.omsOrderExportTask().then(res => { 
        console.log('task:',res)
        let taskId = res.data && res.data.taskId
        if (!taskId) return false
        this.btnExportLoading = true
        let url = res.data.downloadUrl
        if (url){
          this.downloadlink(url)
          this.btnExportLoading = false
          // 删除任务
          setTimeout(() => { 
            this.$api.omsOrderExportDelete()
          }, 800)
          return false
        }
        // 添加轮询逻辑，每60秒检查一次，直到taskId和url都为真
        const pollInterval = setInterval(() => {
          if (taskId && url) {
            
            clearInterval(pollInterval)
            // 执行获取到taskId和url后的逻辑
            console.log('获取到taskId和url:', taskId, url)
            // 在这里可以添加获取到taskId和url后的处理逻辑
            this.downloadlink(url)
            this.btnExportLoading = false
            // 删除任务
            setTimeout(() => { 
              this.$api.omsOrderExportDelete()
            }, 800)
            return false
          } else {
            // 重新获取数据
            this.$api.omsOrderExportTask().then(res => {
              taskId = res.data.taskId
              url = res.data.downloadUrl
              console.log('重新获取task:', res)
            }).catch(err => {
              console.error('获取task失败:', err)
              clearInterval(pollInterval)
            })
          }
        }, 1000 * 10) // 每10秒轮询一次
        
        // 设置10分钟后超时
        setTimeout(() => {
          clearInterval(pollInterval)
          this.btnExportLoading = false
        }, 1000 * 60 * 10)
      })
    },
    fetchData(){
      console.log('>>','fetchData')
      this.$parent.fetchData()
    }
  }
}
</script>
<style lang='scss' src="@/pages/orderBox/saleOrder/style/popDialog.scss"></style>
<style lang='scss' src="../style/orderMain.scss" scoped></style>
<!-- table 内嵌样式 -->
<style lang="scss">
// .ellipsis{
//   line-height: 16px;
//   margin: -2px 0;
// }
td.nowrap .cell{
  white-space: nowrap;
}
td.nowrap .cell .text{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
td.primary .cell{
  color: #409eff!important;
}
td.gary .cell{
  color: #7F7F7F!important;
}
.hover-row{
  &:hover{
    .i-circle-detail,
    .i-circle-sync,
    .i-circle-edit,
    .i-circle-set{
      display: block;
    }
  }
}
%i-circle{
  display: none;
  cursor: pointer;
  position: absolute;
  right: 3px;
  bottom: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-size: 100%;
  font-size: 0;
  transition: .3s;
}
.i-circle-detail{
  @extend %i-circle;
  background-image: url("~@/assets/sale/i-circle-detail.png");
}
.i-circle-sync{
  @extend %i-circle;
  background-image: url("~@/assets/sale/i-circle-sync.png");
}
.i-circle-edit{
  @extend %i-circle;
  background-image: url("~@/assets/sale/i-circle-edit.png");
}
.i-circle-set{
  @extend %i-circle;
  background-image: url("~@/assets/sale/i-circle-set.png");
}
.i-self-pickup{
  border: 1px solid #409EFF;
  color: #409EFF;
  font-size: 11px;
  background-color: #FFF;
  line-height: 1;
  padding: 1px 2px 2px;
  border-radius: 2px;
  margin-right: 2px;
}

// 订单标记
.order-tag{
  display: inline-block;
  box-sizing: border-box;
  min-width: 17px;
  padding: 1px 2px 2px;
  height: 18px;
  background: #FEF2F2;
  border-radius: 1px;
  border: 1px solid #F8BDBD;
  color: #F33F3F;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin-top: 3px;
}
// 订单状态 1 - 10
// 1 私域待提交 白色
// 2 私域待审核 灰色
// 3 私域审核不通过 黄色
// 4 公域待付款 灰色
// 5 公域已付款待审核 灰色
// 6 发货中 蓝色
// 7 已发货 青色
// 8 已收货 绿色
// 9 已取消 红色
// 10 自提中 深灰色
%order-status {
  // position: absolute;
  // inset: 0;
  // display: flex;
  // flex-wrap: wrap;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  padding: 0;
  // margin: -6px;
  // position: relative;
  // margin: -6px;
  // min-height: 42px;
  .text,
  .order-status-tag{
    position: relative;
    z-index: 2;
  }
  .bg{
    position: absolute;
    inset: 0;
    z-index: 1;
  }
  
}

.order-status-1{
  @extend %order-status;
  .text{
    color: #333333;
  }
  .bg{
    background-color: #FFF;
  }
}
.order-status-2,.order-status-4,.order-status-5{
  @extend %order-status;
  .bg{
    background-color: #E5E5E5;
  }
  
}
.order-status-3{
  @extend %order-status;
  .bg{
    background-color: #FFEF40;
  }
}
.order-status-6{
  @extend %order-status;
  .text{
    color: #FFF;
  }
  .bg{
    background-color: #409EFF;
  }
}
.order-status-7{
  @extend %order-status;
  .text{
    color: #FFF;
  }
  .bg{
    background-color: #33CCB0;
  }
}
.order-status-8{
  @extend %order-status;
  .text{
    color: #FFF;
  }
  .bg{
    background-color: #7BCA40;
  }
}
.order-status-9{
  @extend %order-status;
   .text{
      color: #FFF;
    }
  .bg{
    background-color: #FF5151;
  }
  .order-status-tag{
    background-color: #fff;
    color:#F33F3F;
  }
}
.order-status-10{
  @extend %order-status;
   .text{
    color: #FFF;
  }
  .bg{
    background-color: #797979;
  }

}
.order-status-tag{
  display: inline-block;
  box-sizing: border-box;
  min-width: 17px;
  padding: 2px 3px 3px;
  height: 17px;
  background: #F33F3F;
  border-radius: 1px;
  color: #FFF;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  margin: 3px 2px 0 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
// 标签样式 1-5
.tag-no{
  display: inline-block;
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  border-radius: 1px;
  border: 1px solid #BFCBE3;
  background-color: #FFF;
  background-size: 16px 16px;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0
}
.tag-14{
  background-image: url('~@/assets/sale/tag-1.png');
}
.tag-15{
  background-image: url('~@/assets/sale/tag-2.png');
}
.tag-16{
  background-image: url('~@/assets/sale/tag-3.png');
}
.tag-17{
  background-image: url('~@/assets/sale/tag-4.png');
}
.tag-18{
  background-image: url('~@/assets/sale/tag-5.png');
}
.tag-no + .tag-text,
.tag-text + .tag-text{
  margin-left: 4px;
}
.tag-text{
  display: inline-block;
  height: 22px;
  padding: 0 3px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 12px;
  line-height: 20px;
  // 强制不换行
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}
.tag-red{
  background: #FEF2F2;
  border: 1px solid #F8BDBD;
  color: #F33F3F;
}
.tag-black{
  background: #D6DCE5;
  border: 1px solid #BFCBEC;
  color: #364665;
}
// 商品信息
.goods-info{
  .hand{
    cursor: pointer;
  }
  .pic{
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    position: relative;
    border: 1px solid #CCCCCC;
    .el-image{
      text-align: center;
      line-height:1;
      font-size: 16px;
      color: #bcbcbc;
      margin: 0 auto;
      width: 28px;
      height: 28px;
      .image-slot{
        line-height: 28px;
      }
      .el-image__placeholder{
        display: none;
      }
    }
  }
  .pic + .pic{
    margin-left: 6px;
  }
  .count{
    width: 16px;
    height: 16px;
    background: rgba(255, 255, 255, .9);
    border-radius: 8px;
    border: 1px solid #CCCCCC;
    box-sizing: border-box;
    position: absolute;
    left: -4px;
    top: -4px;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #409EFF;
  }
}
 // 审核状态
  .text-default{
    color: #333333;
  }
  .text-red{
    color: #F33F3F ;
  }
  .text-blue{
    color: #409EFF;
  }
  .text-gray{
    color: #999;
  }
  .text-remark{
    color: #7F7F7F;
  }
</style>
